/**
 * PRD3011_R01(생산실적 - BOM/FIFO 자동취합) 품목 라벨 빌더
 *
 * PRD3010과 달리 사용자가 LOT을 직접 선택/생성하지 않고, 서버가 FIFO로
 * 자재 LOT을 자동 소모한다(wmsStockLotDtoList는 항상 빈 배열로 전송됨).
 * 따라서 완성품 라벨도 LOT 단위가 아니라 헤더의 productQty(사용자 입력값)를
 * 그대로 써서 "저장 1건 = 라벨 1장"으로 출력한다.
 */
import { ItemLabelPrintData } from "src/apis/itemLabelApi";
import { formatDate } from "src/utils/string/stringUtil";
import { PRD3011_R01HeaderDto } from "./Dto_PRD3011_R01";

/** 수량 포맷 (콤마 + 단위) */
const formatQty = (qty: number | undefined, unit: string): string => {
	if (!qty && qty !== 0) return '';
	return `${qty.toLocaleString()}${unit || 'EA'}`;
};

/**
 * 저장된 헤더(editPRD3011_R01) → ItemLabelPrintData 1건 변환
 * handleSaveClick의 저장 성공 처리부에서 호출한다.
 */
export const PRD3011_R01_buildItemLabelData = (
	header: PRD3011_R01HeaderDto
): ItemLabelPrintData => {
	if (!header) throw new Error('생산실적 정보가 없어 라벨을 생성할 수 없습니다.');
	if ((header.productQty || 0) <= 0) throw new Error('생산수량이 없어 라벨을 생성할 수 없습니다.');

	const transportDate = header.productDt
		? formatDate(new Date(header.productDt))
		: formatDate(new Date());

	return {
		itemCd: header.itemCd || '',
		itemNm: header.itemNm || '',
		itemSpec: header.itemSpec || '',
		qty: formatQty(header.productQty, header.itemUnit || 'EA'),
		transportDate,
		storageLocation: '-',
		customer: header.customNm || '',
		customerItemCd: header.itemCd || '',
		labelType: '[생산입고]',
	};
};
